import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { config } from '../../../config/index'
import Modal from '../../../components/modal';

// Custom Dropdown Component
const Index = ({ stageId, onDelete }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);

  // Function to toggle dropdown visibility
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const toggleModal = () => {
    setShowModal((prev) => !prev);
  };

  // Function to close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (!event.target.closest(`#dropdown-${stageId}`)) {
        setIsOpen(false);
      }
    };

    // Add event listener to close dropdown on outside click
    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, [stageId]);

  // Function to handle deletion
  const handleDelete = async () => {
   
      const token = localStorage.getItem('auth_token'); // Assuming you stored the token in local storage
      try {
        const response = await axios.delete(config.api_path+`/estate-noticeboards/${stageId}`, {
          headers: {
            Authorization: `Bearer ${token}`, // Add the token in the Authorization header
          },
        });

        if (response.status === 200) {
          toast.success('Message deleted successfully!'); // Show success toast
          onDelete(stageId); // Call the onDelete function passed from the parent
        } else {
          toast.error('Failed to boda stage. Please try again.'); // Show error toast
        }
      } catch (error) {
        console.error('Error deleting boda stage:', error);
        toast.error('An error occurred while deleting the boda stage.'); // Show error toast
      }finally{
        toggleModal(); // Close the modal after deletion attempt
    }
  };

  return (
    <>
    <Modal toggleModal={toggleModal}
             showModal={showModal} 
             handleDelete={handleDelete} 
             title="messae" 
      />
       
    <div className="dropdown" id={`dropdown-${stageId}`} style={{ position: 'relative' }}>
      <button
        className="btn btn-outline-primary"
        type="button"
        onClick={toggleDropdown}
        aria-haspopup="true"
        aria-expanded={isOpen ? 'true' : 'false'}
      >
        Actions
      </button>
      <div className={`dropdown-menu ${isOpen ? 'show' : ''}`} style={{ display: isOpen ? 'block' : 'none', position: 'absolute', top: '100%', zIndex: 1 }}>
        <Link className="dropdown-item" to={`/estate-noticeboard/${stageId}/edit`}>Edit</Link>
        <button className="dropdown-item" 
            onClick={toggleModal}
            disabled={isDeleting}
          >
          Delete
        </button>
      </div>
    </div>
    </>
  );
};

export default Index;
